import {Temp} from "../utils/Temp.js";
import {DDAction, DDEvent} from "./DropDownStateMachine.js";

export const WIDTH_AS_WIDGET = -1;

const ALPHANUM = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_";

export class ManagedDropDown {
	/**
	 * @param widget widget under which should be drop down placed (probably <input>)
	 * @param {DropDownStateMachine} state
	 * @param {string} field
	 */
	constructor(widget, state, field) {
		this.widget = widget;
		this.state = state;
		this.field = field;
		this.uid = ManagedDropDown.generateUid(field);
		this.state.listen(this.stateAction.bind(this));
	}

	get ui() {
		if (this.root == null) this.rebuild();
		return this.root;
	}

	stateAction(action, param) {
		switch (action) {
			case DDAction.SHOW_DROP_DOWN:
				this.show();
				break;
			case DDAction.HIDE_DROP_DOWN:
				this.hide();
				break;
		}
	}

	rebuild() {
		this.root = this.makePanel();
		this.root.on('mouseenter', function() {
			this.state.event(DDEvent.PANEL_ENTER);
			this.unregisterBodyClick();
		}.bind(this));
		this.root.on('mouseleave', function() {
			this.registerBodyClick();
			this.state.event(DDEvent.PANEL_LEAVE);
		}.bind(this));

		this.widget.on('mouseenter', this.unregisterBodyClick.bind(this));
		this.widget.on('mouseleave', this.registerBodyClick.bind(this));
	}

	show() {
		if (this.cancelDropDownHide()) {
			this.beforeShow();
			$("body").append(this.ui);
		}
	}

	hide() {
		if (this.hideTimeout == null) {
			this.hideTimeout = setTimeout(function () {
				this.ui.detach();
				this.hideTimeout = null;
				this.unregisterBodyClick();
			}.bind(this), 100);
		}
	}

	/**
	 * Overwrite this to do stuff just before dd display
	 */
	beforeShow() {
		let wo = this.widget.offset();
		let height = this.widget.outerHeight(false);
		//console.log("Widget offset = " + JSON.stringify(wo) + ", height = " + height);

		// Screen
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
		var spaceAbove = Math.floor(wo.top - viewportTop);
		var spaceBellow = Math.floor(viewportBottom - wo.top - height);
		//console.log("Above = " + spaceAbove + ", Bellow = " + spaceBellow);

		let place = null;
		// Select where to place dropdown ... bottom preferred
		if (spaceBellow > this.getMinHeight()) {	// absolute minimum to consider bottom placement
			place = "bottom";
		} else {
			if (spaceAbove > this.getMinHeight()) place = "top";
			else place = spaceBellow >= spaceAbove ? "bottom" : "top";
		}

		if (place === "bottom") {
			this.ui
				.css("bottom", "")
				.css("top", Math.floor(wo.top + height + 3) + "px")
				.css("left", Math.round(wo.left) + "px");
			let maxHeight = this.getMaxHeight() === 0 ? (spaceBellow - 4) : Math.min(this.getMaxHeight(), spaceBellow - 4);
			this.ui.css("max-height", maxHeight + "px");
		} else {
			const docBottom = $(document).height();
			const wTopFromBottom = docBottom - wo.top;
			//console.log("doc bottom = " + docBottom);
			this.ui
				.css("top", "")
				.css("bottom", Math.floor(docBottom - wo.top + 3) + "px")
				.css("left", Math.round(wo.left) + "px");
			let maxHeight = this.getMaxHeight() === 0 ? (spaceAbove - 4) : Math.min(this.getMaxHeight(), spaceAbove - 4);
			this.ui.css("max-height", maxHeight + "px");
		}
	}

	cancelDropDownHide() {
		if (this.hideTimeout != null) {
			clearTimeout(this.hideTimeout);
			this.hideTimeout = null;
			return false;
		}
		return true;
	}

	makePanel() {
		return Temp.tag('div', {clazz: 'dd'});
	}

	registerBodyClick() {
		const eventName = "mouseup."+this.uid;
		$("body").on(eventName, function() {
			this.state.event(DDEvent.BODY_CANCEL);
		}.bind(this));
		//console.log("ON  " + eventName);
	}

	unregisterBodyClick() {
		const eventName = "mouseup."+this.uid;
		$("body").off(eventName);
		//console.log("OFF " + eventName);
	}

	/**
	 * @return {number} minimum width of dropdown. Use WIDTH_AS_WIDGET constant to set min width to the same value as widget width. 0 = unset
	 */
	getMinWidth() {
		return 0;
	}

	/**
	 * @return {number} maximum width of dropdown. Use WIDTH_AS_WIDGET constant to set max width to the same value as widget width. 0 = unset
	 */
	getMaxWidth() {
		return 0;
	}

	/**
	 * @return {number} Minimum height of sreen space to place dd panel. Used to decide if the panel will be bellow or above widget. Default 80.
	 */
	getMinHeight() {
		return 80;
	}

	/**
	 * @return {number} maximum height of dropdown panel. 0 = maximum height is determined by screen real estate
	 */
	getMaxHeight() {
		return 0;
	}

	/**
	 * Generate id from field name
	 * @param field
	 */
	static generateUid(field) {
		let result = "";
		for (let i = 0; i < field.length; i++) {
			let ch = field.charAt(i);
			if (ALPHANUM.indexOf(ch) >= 0) result = result + ch;
			else result = result + "_";
		}
		return result;
	}
}
